// extracted by mini-css-extract-plugin
export default {"socialContainer":"social_socialContainer__S4Cub","tab":"social_tab__91jmT","itemIcon":"social_itemIcon__Cp3YY"};